export const setCurrencySymbol = (currency: string, value: string | number) => {
  switch (currency) {
    case '₽':
      return `${value}₽`
    case '$':
      return `$${value}`
    case '€':
      return `€${value}`
    default:
      return
  }
}
